import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Star } from 'lucide-react';
export function BonusSection() {
  return <section className="py-12 bg-gradient-to-b from-blue-900 to-gray-900 text-white overflow-hidden" data-id="element-14">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <span className="inline-block bg-yellow-500 text-black font-bold px-4 py-1 rounded-full text-sm mb-4" data-id="element-17">
            OFERTA ESPECIAL HOY
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-18">
            Llevate todo el Megapack + Bonos Exclusivos
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-19">
            No solo te llevás el sistema de clases, también incluimos
            herramientas extra para potenciar tu enseñanza.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex-1" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/dFkjyvnqo8ERC7s1gg3Jtv/kkXXjm1513828.webp" alt="Bonos exclusivos Pack Inglés" className="w-full rounded-lg shadow-2xl border-4 border-white/10" data-id="element-22" />
          </motion.div>

          <div className="flex-1 space-y-8" data-id="element-23">
            <div className="bg-white/10 p-6 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-24">
              <div className="flex items-start gap-4" data-id="element-25">
                <div className="bg-yellow-500 p-3 rounded-lg text-black" data-id="element-26">
                  <Gift className="w-6 h-6" data-id="element-27" />
                </div>
                <div data-id="element-28">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-29">
                    BONO #1: Ebooks & Guías PDF
                  </h3>
                  <p className="text-gray-300" data-id="element-30">
                    Material complementario para profundizar en temas
                    específicos y tener siempre recursos a mano.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 p-6 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-31">
              <div className="flex items-start gap-4" data-id="element-32">
                <div className="bg-yellow-500 p-3 rounded-lg text-black" data-id="element-33">
                  <Star className="w-6 h-6" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-36">
                    BONO #2: Audio Guides
                  </h3>
                  <p className="text-gray-300" data-id="element-37">
                    Recursos de audio para practicar listening y pronunciación
                    con tus alumnos.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 p-6 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-38">
              <div className="flex items-start gap-4" data-id="element-39">
                <div className="bg-yellow-500 p-3 rounded-lg text-black" data-id="element-40">
                  <Gift className="w-6 h-6" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-43">
                    BONO #3: Licencia de Reventa (MRR/PLR)
                  </h3>
                  <p className="text-gray-300" data-id="element-44">
                    ¡Increíble! Podés usar este material e incluso revenderlo si
                    quisieras. Tu inversión vuelve multiplicada.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center md:text-left pt-4" data-id="element-45">
              <p className="text-2xl font-bold text-white mb-2" data-id="element-46">
                Valor total de los bonos:{' '}
                <span className="text-red-400 line-through" data-id="element-47">$45.000</span>
              </p>
              <p className="text-3xl font-bold text-green-400" data-id="element-48">HOY: GRATIS</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}